export const hasParamInUrl = (param: string) =>
  new URLSearchParams(window.location.search).has(param);

export const getParamFromUrl = (param: string) =>
  new URLSearchParams(window.location.search).get(param);
